import React, { useEffect, useState } from 'react'
import { Titles } from '../../constant/PageTitle'
import { Avatar, Button, Card, Input, Pagination, Space, Spin, } from 'antd'
import '../../style/page.css'
import { HeartHandshake, SearchIcon, } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';

import AddRelationType from './AddRelationType';
import ModuleAction from '../modules/ModuleAction';
import { getRelationType, setPagination, setSearchParams } from '../../feature/relation/RelationTypeSlice';


function RelationType() {
    const dispatch = useDispatch()
    const [value, setValue] = useState("");

    const { relationTypeList, isLoading, totalPage, limit, current, searchParams } = useSelector((state) => state.relations);

    const handlePagination = (page) => {
        console.log("page", page)
        dispatch(setPagination(page))
    };


    const fetchRelationList = async () => {
        dispatch(getRelationType({ current, limit, searchParams }));
    }
    useEffect(() => {
        fetchRelationList()
    }, [current, searchParams])



    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(setSearchParams(value));
        }, 1000);

        return () => clearTimeout(timer);
    }, [value]);

    function handleSearch(e) {
        setValue(e.target.value);
    }
    return (
        <section>
            <Card>
                <div className="page_title">
                    <p>{Titles.relation}</p>
                    <Space>
                        <Input allowClear size='large' suffix={<SearchIcon color='lightGray' size={16} />} placeholder="Search" onChange={handleSearch} variant="filled" />
                        <AddRelationType />
                    </Space>
                </div>
            </Card>
            <div className="page_content">
                {isLoading ? <Spin  fullscreen /> :
                    <div className="show_relation">
                        {relationTypeList.map((item, index) => (
                            <>
                                <Card key={index} hoverable >
                                    <Space>
                                        <Avatar icon={<HeartHandshake />} style={{ background: "#25B5F8" }} />
                                        <h3>{item.relationCode}</h3>
                                    </Space>
                                    <div className="options">
                                        <ModuleAction types="relation" editData={item} />
                                    </div>
                                </Card>
                            </>
                        ))}
                    </div>
                }
            </div>
            <div className="pagination">
                <Pagination
                    current={current}
                    onChange={handlePagination}
                    total={totalPage ? totalPage * 10 : 0}
                />
            </div>
        </section >
    )
}

export default RelationType